import React, {
  ReactNode,
} from 'react';

type ChartCardProps = {
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  rightSlot?: ReactNode;
  badges?: ReactNode;
};

export default function ChartCard({
  title,
  children,
  footer,
  rightSlot,
  badges,
}: ChartCardProps) {
  return (
    <div className="rounded-2xl border border-gray-200 p-4">
      <div className="mb-3 flex items-start justify-between gap-3">
        <div className="flex min-w-0 flex-1 flex-wrap items-center gap-2">
          <h3 className="text-[11px] font-semibold uppercase tracking-wide text-gray-600">
            {title}
          </h3>
          {badges}
        </div>
        {rightSlot ? (
          <div className="flex shrink-0 items-center gap-2">{rightSlot}</div>
        ) : null}
      </div>
      {children}
      {footer ? (
        <div className="mt-2 text-right text-[11px] text-gray-500">{footer}</div>
      ) : null}
    </div>
  );
}
